import React from "react";
import PropTypes from "prop-types";
import PreOrderBlackIcon from "./pre_order_black_24dp.svg?react";
import PreOrderWhiteIcon from "./pre_order_white_24dp.svg?react";

export default function PreOrderIcon(props) {
	return <div>{props.white ? <PreOrderWhiteIcon /> : <PreOrderBlackIcon />}</div>;
}

PreOrderIcon.propTypes = {
	white: PropTypes.bool,
};
